import React, { useMemo } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails } from 'models/travelDetails';

import { TravelData } from './styles';

interface Props {
  data: TravelDetails;
}

const TravelDataDescription = ({ data }: Props) => {
  const { t } = useStoreTranslation();

  const qtyDays = useMemo(
    () =>
      data.vehicle
        ? data.vehicle.quantityDays > 1
          ? t('travelDetails.solicitation.days_plural', { count: data.vehicle?.quantityDays })
          : t('travelDetails.solicitation.days', { count: data.vehicle?.quantityDays })
        : '',
    [data.vehicle, t],
  );

  return data.air ? (
    <>
      {data.requester.locator && (
        <TravelData>{t('travelDetails.solicitation.flight', { text: data.requester.locator })}</TravelData>
      )}
      <TravelData>{t('travelDetails.solicitation.eTicket', { value: data.requester.eticket })}</TravelData>
      <TravelData>{t('travelDetails.solicitation.passenger', { name: data.requester.fullName })}</TravelData>
    </>
  ) : data.hotel ? (
    <>
      <TravelData>{t('travelDetails.solicitation.confirmationCode', { code: data.hotel?.confirmation })}</TravelData>
      <TravelData>{t('travelDetails.solicitation.guest', { name: data.requester.fullName })}</TravelData>
      <TravelData>{t('travelDetails.solicitation.nights', { count: data.hotel?.quantityDays })}</TravelData>
    </>
  ) : (
    <>
      <TravelData>
        {t('travelDetails.solicitation.orderNumber')}: {data.vehicle?.orderNumber}
      </TravelData>
      <TravelData>{t('travelDetails.solicitation.driver', { name: data.requester.fullName })}</TravelData>
      <TravelData>{qtyDays}</TravelData>
    </>
  );
};

export default TravelDataDescription;
